/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBankFileReturn = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M21 2H3v20h10.757l-2-2H5V4h14v10.694L20 16h1zM10.757 19l2-2H6v2zM15 14.757l2-2V12h-2zM9.85 9h4.3L12 7.28zm1.525-3.78a1 1 0 0 1 1.25 0l5 4A1 1 0 0 1 17 11H7a1 1 0 0 1-.625-1.78zM7 15.95V12h2v3.95zm4 0V12h2v3.95zm7.707 5.343L17.414 20H21v2h2v-4h-5.586l1.293-1.293-1.414-1.414L13.586 19l3.707 3.707z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBankFileReturn as BankFileReturn };
